import React from "react";
import { FeatureSafe } from "./FeatureSafe";

const FORWARD_REF = Symbol.for("react.forward_ref");

export const withFeatureSafe = (Comp, options = {}) => {
  const componentName =
    options.name || Comp.displayName || Comp.name || "Component";

  if (Comp.$$typeof === FORWARD_REF) {
    const Wrapped = React.forwardRef((props, ref) => (
      <FeatureSafe
        componentName={componentName}
        fallback={options.fallback}
        silent={options.silent}
      >
        <Comp {...props} ref={ref} />
      </FeatureSafe>
    ));
    Wrapped.displayName = `Safe(${componentName})`;
    return Wrapped;
  }

  const Wrapped = (props) => (
    <FeatureSafe
      componentName={componentName}
      fallback={options.fallback}
      silent={options.silent}
    >
      <Comp {...props} />
    </FeatureSafe>
  );
  Wrapped.displayName = `Safe(${componentName})`;
  return Wrapped;
};

/** @deprecated Use withFeatureSafe — alias for Safe(Comp) pattern */
export const Safe = withFeatureSafe;
